import { appSettings } from "../AppSettings";
import { withProfile } from "../Utils";
import session from "./Session";

export interface IEvent {

    titoloEvento: string;
    dataEvento: string;
    oraEvento: string;
    idEvento: string;
    checkMode: "COUNT" | "SCAN";
    syncOffline?: number;
}

export interface IVerifyTicketData {
    eventID: string;
    ref_gate: string;
    barcode: string;
    direction: "E" | "X";
    ref_device: string;
    log_date?: string;
    log_time?: string;
}


export interface IUpdateCounterData {
    eventID: string;
    ref_gate: string;
    counter: number;
    ref_device: string;
}


export interface IVerifyTicketResponse {
    type: "OK" | "KO";
    code: string;
    msg: string;
    msg_data: string;
    color?: string;
    isOffline?: boolean;
}

export interface IEventStats {
    Entrati: number;
    Attesi: number;
    Totale: number;
    Settore?: string;
}

export interface IEventGate {
    gate_name: string;
    gate_code: string;
}

export interface ITIcketDataFilter {
    eventID: string;
    searchMethod: string;
    searchString: string;
}

export interface ITicketData {
    cartaattivazione: string;
    sigillofiscale: string;
    sistemaemissione: string;
    riferimentoordine: string;
    dataemissione: string|number;
    oraemissione: string;
    barcode: string;
    cognome: string;
    nome: string;
    fila: string;
    posto: string;
    noteblocco: string;
    settorefisico: string;
    datanascita: string;
    luogonascita: string;
    stato: string;
    causale: string;
    tipotitolo: string;
    dataingressocontrollo: string|number;
    oraingressocontrollo: string | number;
    idsettore: string;
    settore: string;
    idblocco: string;
}


export interface IWhiteList extends ITicketData {
    tipose: string;
    codsupportoid: string;
    codiceordine: string;
}


type ErrorResponse = { error: string }[]

function isError(msg: any): msg is ErrorResponse {
    return Array.isArray(msg) && msg.length == 1 && msg[0]["error"];
}


export class HttpError {

    constructor(response: Response) {
        this.response = response;
    }

    readonly response: Response;
}

class ApiClient {

    protected _accessToken: string = "A4A393fj9dc9498cb9b99383449cv89b";
    protected _baseUrl: string;

    open(baseUrl: string, accessToken: string) {
        this._accessToken = accessToken;
        this._baseUrl = baseUrl;
    }

    async getActiveEventsAsync() {
        const result = await this.execAsync<IEvent[] | ErrorResponse>("AXC_Core/Reader_GetActiveEvents", "GET");
        if (isError(result))
            return [];
        return result;
    }

    async verifyTicketAsync(data: IVerifyTicketData) {
        
        const result = await withProfile(()=>this.execAsync<IVerifyTicketResponse[] | ErrorResponse>("AXC_Core/Reader_doVerifyTicket", "GET", data), "Reader_doVerifyTicket");
        if (isError(result))
            throw result[0].error;
        return result;
    }

    async getScanStatsAsync(eventId: string) {

        const result = await this.execAsync<IEventStats[] | ErrorResponse>("AXC_Core/Reader_GetEventStats", "GET", { eventID: eventId });
        if (isError(result))
            return {} as IEventStats;
        return result[0];
    }

    async getScanStatsDetailsAsync(eventId: string) {

        const result = await this.execAsync<IEventStats[] | ErrorResponse>("AXC_Core/Reader_GetEventStats_Detailed", "GET", { eventID: eventId });
        if (isError(result))
            return [];
        return result;
    }

    async getCountStatsAsync(eventId: string) {

        const result = await this.execAsync<IEventStats[] | ErrorResponse>("AXC_Core/Reader_ContaPersone_GetEventStats", "GET", { eventID: eventId });
        if (isError(result))
            return {} as IEventStats;
        return result[0];
    }

    async getEventGatesAsync(eventId: string) {

        const result = await this.execAsync<IEventGate[] | ErrorResponse>("AXC_Core/Reader_GetEventGates", "GET", { eventID: eventId });
        if (isError(result))
            return [];
        return result;
    }

    async getTicketDataAsync(filter: ITIcketDataFilter) {
        const result = await this.execAsync<ITicketData[] | ErrorResponse>("AXC_Core/Reader_GetTicketData", "GET", filter);
        if (isError(result))
            return [];
        return result;
    }

    async getWhiteListAsync(eventId: string) {
        const result = await this.execAsync<IWhiteList[] | ErrorResponse>("AXC_Core/Reader_GetWhitelist", "GET",
        {
            eventID: eventId
        });
        if (isError(result))
            return [];
        return result;
    }

    async updateCounterAsync(data: IUpdateCounterData) {
        const result = await this.execAsync<string>("AXC_Core/Reader_ContaPersone_addValue", "GET", data, true);
        return result == "OK";
    }

    async pingAsync() {
        const result = await this.execAsync<string>("AXC_Core/Reader_AreYouAlive", "GET", null, true, appSettings.pingTimeout);
        return result == "True";
    }

    protected async execAsync<T>(url: string, method: string, data?: any, isText = false, timeout: number = 0): Promise<T> {
        url = this._baseUrl + url + "?";

        data = {
            ...data,
            pin: session.pin,
            token: this._accessToken,
            "no-cache": 1
        }

        for (const key in data)
            url += key + "=" + encodeURIComponent(data[key]) + "&";

        const controller = new AbortController();

        if (timeout) 
            setTimeout(() => controller.abort(), timeout);
        
        const response = await fetch(url, {
            
            method,
            signal: controller.signal
        });

        if (!response.ok)
            throw new HttpError(response);

        const text = await response.text();
        if (isText)
            return text as any;
        return JSON.parse(text);
    }
}

const apiClient = new ApiClient();

export default apiClient;